import React, { useLayoutEffect } from "react";
import L from "leaflet";
import { FeatureCollection } from "geojson";
import { StyleFunction, Layer } from "leaflet";

interface IGeoJSON {
  stylePolygn: StyleFunction<any>;
  mapRef: React.MutableRefObject<L.Map | undefined>;
  data: FeatureCollection;
  onHover?: ((feature: any, layer: Layer) => void) | null;
  geoJsonRef: React.MutableRefObject<any>;
}

export const GeoJSON = ({
  geoJsonRef,
  stylePolygn,
  mapRef,
  data,
  onHover,
}: IGeoJSON) => {
  useLayoutEffect(() => {
    if (!mapRef.current) return;
    const geoJson = L.geoJSON(data, {
      style: stylePolygn,
      onEachFeature: onHover!,
    });
    geoJsonRef.current = geoJson.addTo(mapRef.current);
  }, [data, geoJsonRef, mapRef, onHover, stylePolygn]);

  return <></>;
};
